import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import FileUploadField from '../../../../BaseModule/Components/Form/Components/FileUpload/FileUploadField';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';
import ImageFileUploadField from '../../../../BaseModule/Components/Form/Components/ImageFileUpload/ImageFileUploadField';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.UPLOAD }>;
}

const WizardUpload: React.FC<Props> = ({ item }) => {
	if (item.subtype === WizardItemSubType.PROFILE_PICTURE) {
		return (
			<ImageFileUploadField
				name={item.key}
				label={item.title}
				isRequired={item.settings?.required}
				isWrapped
			/>
		);
	}

	return (
		<FileUploadField
			name={item.key}
			label={item.title}
			isRequired={item.settings?.required}
			isWrapped
		/>
	);
};

export default WizardUpload;
